import React, { useState } from 'react';
import { Modal, Backdrop, Fade, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TutorialVideos from '../../../assests/Constants/tutorialVideosConstants';
import VideoPlayerModal from '../VideoPlayerModal/VideoPlayerModal';

const TutorialVideosModal = ({ 
    open, 
    onClose, 
    direction = 'rtl' 
}) => {
    const { t } = useTranslation();
    const [selectedVideoType, setSelectedVideoType] = useState(null);
    const [selectedVideo, setSelectedVideo] = useState(null);

    const handleClose = () => {
        setSelectedVideoType(null);
        setSelectedVideo(null);
        onClose();
    };
    const handleBack = () => {
        setSelectedVideoType(null);
        setSelectedVideo(null);
    };

    return (
        <>
            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{ 
                    timeout: 500,
                    style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' }
                }}
            >
                <Fade in={open}>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: { xs: '90%', sm: '600px' },
                            maxWidth: '600px',
                            bgcolor: 'background.paper',
                            borderRadius: '16px',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                            outline: 'none',
                            boxSizing: 'border-box',
                            '& *': {
                                boxSizing: 'border-box',
                            },
                        }}
                        dir={direction}
                    >
                        {/* Header */}
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                p: 3,
                                pb: 2,
                                borderBottom: '2px solid #F5F5F6'
                            }}
                        >
                            <Box
                                component="h4"
                                sx={{
                                    m: 0,
                                    fontSize: '22px',
                                    fontWeight: 700,
                                    color: '#1A1A1A',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.25
                                }}
                            >
                                <Box
                                    component="span"
                                    sx={{
                                        width: '4px',
                                        height: '24px',
                                        background: 'linear-gradient(135deg, #304FFF 0%, #F9AA2A 100%)',
                                        borderRadius: '2px'
                                    }}
                                />
                                {selectedVideoType ? TutorialVideos[selectedVideoType].title : t('TutorialVideos')}
                            </Box>
                            <Box
                                component="button"
                                onClick={selectedVideoType ? handleBack : handleClose}
                                sx={{
                                    background: '#F5F5F6',
                                    border: 'none',
                                    borderRadius: '8px',
                                    width: '32px',
                                    height: '32px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    padding: 0,
                                    '&:hover': {
                                        background: '#E0E0E0',
                                        transform: 'rotate(90deg)'
                                    }
                                }}
                            >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M12 4L4 12M4 4L12 12" stroke="#666" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                            </Box>
                        </Box>

                        {/* Content */}
                        <Box sx={{ p: 3 }}>
                            {!selectedVideoType ? (
                                // Video type selection - Compact Xtram Style
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                    <Box
                                        component="button"
                                        onClick={() => setSelectedVideoType('rivhit')}
                                        sx={{
                                            width: '100%',
                                            p: 2,
                                            background: 'white',
                                            border: '2px solid #E5E7EB',
                                            borderRadius: '12px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            textAlign: 'left',
                                            '&:hover': {
                                                borderColor: '#304FFF',
                                                background: '#F8F9FF',
                                                transform: 'translateX(-2px)'
                                            }
                                        }}
                                    >
                                        <Box
                                            component="span"
                                            sx={{
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                color: '#1A1A1A'
                                            }}
                                        >
                                            ריווחית
                                        </Box>
                                        <Box
                                            component="span"
                                            sx={{
                                                width: '8px',
                                                height: '8px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #F9AA2A 0%, #FF6B6B 100%)',
                                                boxShadow: '0 2px 8px rgba(249, 170, 42, 0.4)'
                                            }}
                                        />
                                    </Box>
                                    <Box
                                        component="button"
                                        onClick={() => setSelectedVideoType('hashavshevet')}
                                        sx={{
                                            width: '100%',
                                            p: 2,
                                            background: 'white',
                                            border: '2px solid #E5E7EB',
                                            borderRadius: '12px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            textAlign: 'left',
                                            '&:hover': {
                                                borderColor: '#304FFF',
                                                background: '#F8F9FF',
                                                transform: 'translateX(-2px)'
                                            }
                                        }}
                                    >
                                        <Box
                                            component="span"
                                            sx={{
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                color: '#1A1A1A'
                                            }}
                                        >
                                            חשבשבת
                                        </Box>
                                        <Box
                                            component="span"
                                            sx={{
                                                width: '8px',
                                                height: '8px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #F9AA2A 0%, #FFD93D 100%)',
                                                boxShadow: '0 2px 8px rgba(249, 170, 42, 0.4)'
                                            }}
                                        />
                                    </Box>
                                    <Box
                                        component="button"
                                        onClick={() => setSelectedVideoType('atzmait')}
                                        sx={{
                                            width: '100%',
                                            p: 2,
                                            background: 'white',
                                            border: '2px solid #E5E7EB',
                                            borderRadius: '12px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            textAlign: 'left',
                                            '&:hover': {
                                                borderColor: '#304FFF',
                                                background: '#F8F9FF',
                                                transform: 'translateX(-2px)'
                                            }
                                        }}
                                    >
                                        <Box
                                            component="span"
                                            sx={{
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                color: '#1A1A1A'
                                            }}
                                        >
                                            עצמאית
                                        </Box>
                                        <Box
                                            component="span"
                                            sx={{
                                                width: '8px',
                                                height: '8px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #F9AA2A 0%, #FFD93D 100%)',
                                                boxShadow: '0 2px 8px rgba(249, 170, 42, 0.4)'
                                            }}
                                        />
                                    </Box>
                                    <Box
                                        component="button"
                                        onClick={() => setSelectedVideoType('sumit')}
                                        sx={{
                                            width: '100%',
                                            p: 2,
                                            background: 'white',
                                            border: '2px solid #E5E7EB',
                                            borderRadius: '12px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            textAlign: 'left',
                                            '&:hover': {
                                                borderColor: '#304FFF',
                                                background: '#F8F9FF',
                                                transform: 'translateX(-2px)'
                                            }
                                        }}
                                    >
                                        <Box
                                            component="span"
                                            sx={{
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                color: '#1A1A1A'
                                            }}
                                        >
                                            Sumit
                                        </Box>
                                        <Box
                                            component="span"
                                            sx={{
                                                width: '8px',
                                                height: '8px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #F9AA2A 0%, #FFD93D 100%)',
                                                boxShadow: '0 2px 8px rgba(249, 170, 42, 0.4)'
                                            }}
                                        />
                                    </Box>
                                    <Box
                                        component="button"
                                        onClick={() => setSelectedVideoType('kodbena')}
                                        sx={{
                                            width: '100%',
                                            p: 2,
                                            background: 'white',
                                            border: '2px solid #E5E7EB',
                                            borderRadius: '12px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            textAlign: 'left',
                                            '&:hover': {
                                                borderColor: '#304FFF',
                                                background: '#F8F9FF',
                                                transform: 'translateX(-2px)'
                                            }
                                        }}
                                    >
                                        <Box
                                            component="span"
                                            sx={{
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                color: '#1A1A1A'
                                            }}
                                        >
                                            קוד בינה
                                        </Box>
                                        <Box
                                            component="span"
                                            sx={{
                                                width: '8px',
                                                height: '8px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #F9AA2A 0%, #FFD93D 100%)',
                                                boxShadow: '0 2px 8px rgba(249, 170, 42, 0.4)'
                                            }}
                                        />
                                    </Box>
                                    <Box
                                        component="button"
                                        onClick={() => setSelectedVideoType('priority')}
                                        sx={{
                                            width: '100%',
                                            p: 2,
                                            background: 'white',
                                            border: '2px solid #E5E7EB',
                                            borderRadius: '12px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            textAlign: 'left',
                                            '&:hover': {
                                                borderColor: '#304FFF',
                                                background: '#F8F9FF',
                                                transform: 'translateX(-2px)'
                                            }
                                        }}
                                    >
                                        <Box
                                            component="span"
                                            sx={{
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                color: '#1A1A1A'
                                            }}
                                        >
                                            Priority
                                        </Box>
                                        <Box
                                            component="span"
                                            sx={{
                                                width: '8px',
                                                height: '8px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #F9AA2A 0%, #FFD93D 100%)',
                                                boxShadow: '0 2px 8px rgba(249, 170, 42, 0.4)'
                                            }}
                                        />
                                    </Box>
                                </Box>
                            ) : (
                                // Video list - Compact Xtram Style
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                    {TutorialVideos[selectedVideoType].videos.map((video) => (
                                        <Box
                                            key={video.id}
                                            onClick={() => setSelectedVideo(video)}
                                            sx={{
                                                p: 2,
                                                background: '#F8F9FF',
                                                border: '1px solid #E5E7EB',
                                                borderRadius: '12px',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1.5,
                                                '&:hover': {
                                                    borderColor: '#304FFF',
                                                    background: 'white',
                                                    boxShadow: '0 4px 12px rgba(48, 79, 255, 0.15)',
                                                    transform: 'translateY(-2px)'
                                                }
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    minWidth: '48px',
                                                    height: '48px',
                                                    background: 'linear-gradient(135deg, #FF0000 0%, #CC0000 100%)',
                                                    borderRadius: '10px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    flexShrink: 0,
                                                    boxShadow: '0 2px 8px rgba(255, 0, 0, 0.25)'
                                                }}
                                            >
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M8 5V19L19 12L8 5Z" fill="white"/>
                                                </svg>
                                            </Box>
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Box
                                                    component="h5"
                                                    sx={{
                                                        m: 0,
                                                        mb: 0.5,
                                                        fontSize: '15px',
                                                        fontWeight: 600,
                                                        color: '#1A1A1A',
                                                        lineHeight: 1.4
                                                    }}
                                                >
                                                    {video.title}
                                                </Box>
                                                <Box
                                                    component="p"
                                                    sx={{
                                                        m: 0,
                                                        fontSize: '13px',
                                                        color: '#6B7280',
                                                        fontWeight: 400,
                                                        lineHeight: 1.4
                                                    }}
                                                >
                                                    {video.description}
                                                </Box>
                                            </Box>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0, opacity: 0.5 }}>
                                                <path d="M9 18L15 12L9 6" stroke="#304FFF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </Box>
                                    ))}
                                    <Box
                                        component="button"
                                        onClick={handleBack}
                                        sx={{
                                            mt: 1,
                                            width: '100%',
                                            p: 1.5,
                                            background: '#F5F5F6',
                                            border: '1px solid #E5E7EB',
                                            borderRadius: '10px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            color: '#6B7280',
                                            '&:hover': {
                                                background: '#E5E7EB',
                                                color: '#1A1A1A'
                                            }
                                        }}
                                    >
                                        ← {t('Back')}
                                    </Box>
                                </Box>
                            )}
                        </Box>
                    </Box>
                </Fade>
            </Modal>

            {/* Video Player Modal */}
            <VideoPlayerModal
                open={!!selectedVideo}
                onClose={() => setSelectedVideo(null)}
                videoUrl={selectedVideo?.url || ''}
                videoTitle={selectedVideo?.title || ''}
                videoDescription={selectedVideo?.description || ''}
                direction={direction}
            />
        </>
    );
};

export default TutorialVideosModal;

